var exports = {
  "t8": "MobileFriendRequestItem.module__requestItem___N3M2dk",
  "eF": "MobileFriendRequestItem.module__userInfo___N3M2dk",
  "nT": "MobileFriendRequestItem.module__userName___N3M2dk",
  "G2": "MobileFriendRequestItem.module__requestStatus___N3M2dk",
  "hP": "MobileFriendRequestItem.module__actionButton___N3M2dk" + " " + __webpack_require__(377561)["AS"] + " " + __webpack_require__(377561)["ik"],
  "RK": "MobileFriendRequestItem.module__iconSize___N3M2dk",
};

module.exports = exports;
